$(function () {
  let isMobile = false;

  let checkFlags = function() {
    if($(window).width() < 768.1) {
        isMobile = true;
    } else {
        isMobile = false;
    }
  }

  $('.js-roll-button').on('click', function(e) {
      if(! isMobile) return;
      let $this = $(this);
      let $hiddenBlock = $this.closest('.js-roll').find('.js-roll-block');

      if ($this.hasClass('is-active')) {
        $this.removeClass('is-active');
        $hiddenBlock.slideUp();
      }
      else {
        $('.js-roll-button').removeClass('is-active');
        $('.js-roll-block').slideUp();
        $this.addClass('is-active');
        $hiddenBlock.slideDown();
      }
  });

  checkFlags();
  $(window).on('resize', function(){
    checkFlags();
  });
});



